<template>
	<form @submit.prevent="onSubmitForm">
		<card>
			<div class="row">
				<div class="col-12 col-md">
					<base-input
						label="Nome cantiere"
						v-validate="'required|min:2'"
						:error="getError('Nome')"
						v-model="model.name"
						name="Name"
						input-size="form-control-lg"
						placeholder="Nome"
					>
					</base-input>
				</div>
				<div class="col-12 col-md">
					<base-input
						label="Nome cliente"
						v-validate="'required|min:2'"
						:error="getError('clientName')"
						v-model="model.clientName"
						name="clientName"
						input-size="form-control-lg"
						placeholder="Nome Cliente"
					>
					</base-input>
				</div>
				<!-- <div class="col-12 col-md">
					<base-input
						label="Dati Società"
						v-validate="'required|min:2'"
						:error="getError('clientFiscalProfile')"
						v-model="model.clientFiscalProfile"
						name="clientFiscalProfile"
						input-size="form-control-lg"
						placeholder="Nome Cliente"
					>
					</base-input>
				</div> -->

				<div class="col-12 col-md">
					<base-input
						label="Indirizzo"
						:error="getError('Nome')"
						v-model="model.address"
						name="address"
						input-size="form-control-lg"
						placeholder="Indirizzo"
					/>
					<!-- <p class="text-muted text-small">Insirisci l'indirizzo nelformato "Via,Comune,Provicia", alle volte anche solo inserire il nome fisico del posto può bastare (ad esempio il nome del cliente)</p> -->
					<p class="text-small">
						<a @click.prevent="openAddress()" href="#" target="_blank">Testa indirizzo</a>
					</p>
				</div>

				<div class="col-12 col-md">
					<base-input
						label="Dati società"
						v-model="model.businessData"
						name="businessData"
						input-size="form-control-lg"
						placeholder="Dati società"
					/>
					
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-md-4">
					<base-input
						label="Label 'Riferimento ordine' nelle revisioni"
						:error="getError('Nome')"
						v-model="model.referenceOrderLabel"
						name="address"
						input-size="form-control-lg"
						placeholder="Rif. ordine"
					/>
					<!-- <p class="text-muted text-small">Insirisci l'indirizzo nelformato "Via,Comune,Provicia", alle volte anche solo inserire il nome fisico del posto può bastare (ad esempio il nome del cliente)</p> -->
				</div>

				<div class="col-12 col-md-4">
					<base-input
						label="Valore 'Riferimento ordine' nelle revisioni"
						:error="getError('Nome')"
						v-model="model.referenceOrder"
						name="address"
						input-size="form-control-lg"
						placeholder="CX29837"
					/>
					<!-- <p class="text-muted text-small">Insirisci l'indirizzo nelformato "Via,Comune,Provicia", alle volte anche solo inserire il nome fisico del posto può bastare (ad esempio il nome del cliente)</p> -->
				</div>
			</div>
		</card>
		<card class="responsive-card-table">
			<div class="row">
				<div class="col-9 col-md-6">
					<h4 class="mt-3">Contatti</h4>
				</div>
				<div class="col-3 col-md-6 text-md-right">
					<base-button type="info" @click="addEmail()">
						<i class="tim-icons icon-simple-add"></i>
						<span class="d-none d-md-inline">Aggiungi contatto</span>
					</base-button>
				</div>
			</div>
			<hr>
			<el-table
				:data="model.emails"
				class="w-100">
				<el-table-column
					label="Email">
					<template slot-scope="scope">
						<base-input
							v-validate="'required|email'"
							:error="getError(`${scope.row._id}email`)"
							v-model="scope.row.email"
							:id="`${scope.row._id}email`"
							:name="`${scope.row._id}email`"
							placeholder="Email"
							type="email"
						>
						</base-input>
					</template>
				</el-table-column>
				<el-table-column
					label="Telefono	">
					<template slot-scope="scope">
						<base-input
							:name="`${scope.row._id}phone`"
							:id="`${scope.row._id}phone`"
							v-model="scope.row.telephone"
							name="telephone"
							placeholder="Numero di telefono"
						>
						</base-input>
					</template>
				</el-table-column>
				<el-table-column
					label="Nome persona">
					<template slot-scope="scope">
						<base-input
							v-validate="'required'"
							:error="getError('Email')"
							v-model="scope.row.contactName"
							name="Nome persona"
							placeholder="Nome"
						>
						</base-input>
					</template>
				</el-table-column>
				<el-table-column
					width="100"
					label="Primaria">
					<template slot-scope="scope">
		                <base-switch
		                  v-model="scope.row.primary"
		                ></base-switch>
					</template>
				</el-table-column>
				<el-table-column
					size="mini"
					label="Azioni"
					width="100"
					>
					<template slot-scope="scope">
						<div class="text-right">
							<base-button type="link" class="text-danger" @click="deleteEmail(scope.$index)">
								<i class="tim-icons icon-trash-simple"></i>
							</base-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</card>
		<div class=" text-center text-md-right">
			<base-button type="primary" native-type="submit" v-if="user.is('backoffice')">
    			<i class="icon-cloud-upload-94 tim-icons" />
				{{submitMessage}}
			</base-button>
		</div>
	</form>
</template>
<script>
import { Table, TableColumn } from 'element-ui';

import {
  BaseSwitch,
  ImageUpload,
} from 'src/components/index';

import { mapState, mapActions } from 'vuex'
import swal from 'sweetalert2';

export default {
	name: 'SiteForm',
	props: {
		model: Object,
		onSubmit: Function,
		submitMessage: {
			type: String,
			default: 'Salva',
		}
	},
	components: {
		[TableColumn.name]: TableColumn,
		[Table.name]: Table,
		BaseSwitch,
		ImageUpload
	},
	computed: {
		...mapState({
			attachmentLoading: state => state.sites.attachmentLoading,
			user: state => state.account.user
		})
	},
	methods: {
	    ...mapActions('sites', {
	      addAttachment: 'addAttachment',
	      deleteAttachment: 'deleteAttachment'
	    }),
		async onSubmitForm() {
		      let isValidForm = await this.$validator.validate();
		      if (isValidForm) {
		      	this.onSubmit();
		      }
		},
		getError(fieldName) {
			return this.errors.first(fieldName);
		},
	    openAddress() {
	    	if ((navigator.platform.indexOf("iPhone") != -1)  ||
				(navigator.platform.indexOf("iPad") != -1) ||
				(navigator.platform.indexOf("iPod") != -1))
				window.open(`maps://maps.google.com/maps?daddr=${this.model.address}&amp;ll=`);
			else /* else use Google */
				window.open(`https://maps.google.com/maps?daddr=${this.model.address}&amp;ll=`);
	    },
		addEmail() {
			this.model.emails.push({
				email: '',
				contactName: '',
				primary: this.model.emails.length === 0
			})
		},
		async deleteEmail(index) {


	        const confirm = await swal.fire({
	            title: 'Sicuro?',
	            // text: "You won't be able to revert this!",
	            type: 'warning',
	            showCancelButton: true,
	            confirmButtonText: 'Elimina elemento',
	            cancelButtonText: 'Annulla',
	            reverseButtons: true
	        })

	        if (confirm.value) {
				this.model.emails.splice(index,1)
			}
		}
	}
}
</script>